import goldImg from './img/goldImg.jpg';
import platinumImg from './img/platinumImg.png';

const includedOptions = [
    'Exterior hand wash & wax',
    'Swirl-free hand dry',
    'Wheel & tire cleaning',
    'Premium tire dressing',
    'Exterior window cleaning',
    'Interior window cleaning',
    'Interior & trunk vacuum',
    'Interior surfaces cleaned',
    'All-season mats cleaned',
    'Minor stain removal',
    'Leather cleaning & conditioning'
]

export const goldPackage = {
    name: "Gold",
    packageImg: goldImg,
    price: 150,
    altPrice: 'Exterior only: $90',
    barText: 'Cost Effective',
    description: 'The perfect balance to refresh your vehicle back to its pristine condition, offering longer protection and hydrophobic technology. Optimum Hyper-Seal provides protection for up to 6 months maintaining superior water beading features.',
    options: [...includedOptions, 
        'Turtle Wax ceramic sealant',
        'Turtle Wax surface dressing',
        'Minor salt stain removal'
    ],
    exteriorOnly: 90,
    backgroundGradient: 'linear-gradient(315deg, #d99058 0%, #f8de7e 74%)'
}

export const platinumPackage = {
    name: 'Platinum',
    packageImg: platinumImg,
    price: 200,
    altPrice: 'Interior/Exterior only: $120',
    barText: 'Superior Protection',
    description: 'The ultimate showtime package to revive your vehicle inside and out. Clay buffing removes bonded contaminates leaving your finish smooth as glass. High speed buffing removes light to moderate swirls, oxidation & paint defects restoring a "new paint" shine.',
    options: [...includedOptions,
        'Opti-Coat® Ceramic Sealant',
        '303® Aerospace surface dressing',
        'Major salt stain removal',
        'Clay bar treatment (partial)',
        'Gloss enhancer',
        'Ceramic window sealant',
        'Ceramic wheel sealant'
    ],
    exteriorOnly: 120,
    interiorOnly: 120
}

export const additionalServices = [
    {name: 'Mobile service', price: 25},
    {name: 'Steam cleaning (disinfectant)', price: 75},
    {name: 'Shampoo mats / base', price: 50},
    {name: 'Shampoo seats', price: 50},
    {name: 'Leather cleaning', price: 25},
    {name: 'Pet hair removal', price: 40},
    {name: 'Roofliner cleaning', price: 40},
    {name: 'Ceramic coating (2 year)', price: 500},
    {name: 'Machine polish', price: 100},
    {name: 'Headlight restoration', price: 60},
    {name: 'Clay bar treatment', price: 50},
    {name: 'Engine bay cleaning', price: 50},
    {name: 'Paint correction', price: "call"}
]